import { AssistantEventHandler } from '@renderer/overlay/Assistant/AssistantEventHandler'
import { AssistantContextHandler } from '@renderer/overlay/Assistant/AssistantContextHandler'
import PerformanceMonitor from '@renderer/features/performance-monitor'
import { usePylon } from '@renderer/providers/PylonProvider'
import { useEffect, memo } from 'react'
import { GlobalEvents } from '@highlight/ipc'
import { useAudioRuntime } from '@renderer/hooks/audio/use-audio-runtime'

const AudioRuntimeMonitor = memo(() => {
  useAudioRuntime()
  return null
})
AudioRuntimeMonitor.displayName = 'AudioRuntimeMonitor'

/**
 * Non-UI handler components that must remain mounted at all times.
 * These components manage critical functionality:
 * - AudioRuntimeMonitor: Renderer-side audio capture (browser-only; in Electron this runs in AudioRuntimeWindow)
 * - AssistantEventHandler: Global events and hotkeys
 * - AssistantContextHandler: Context auto-detection and meeting transcription
 * - PerformanceMonitor: Performance tracking
 *
 * ⚠️ CRITICAL: If these handlers aren't mounted, the following breaks:
 * - Hotkeys (search, summon, tray menu)
 * - Context auto-detection (screenshots, text selection)
 * - Meeting transcription auto-start
 * - Update notifications
 */
export const AssistantHandlers = memo(() => {
  const { show } = usePylon()
  useEffect(() => {
    if (window.__RENDERER_NAME !== 'overlay') {
      return
    }
    const onChatWithSupport = () => {
      console.log('tray:chatWithSupport')
      show()
    }
    GlobalEvents.on('tray:chatWithSupport', onChatWithSupport)
    return () => {
      GlobalEvents.off('tray:chatWithSupport', onChatWithSupport)
    }
  }, [show])

  return (
    <>
      {__IS_BROWSER__ && <AudioRuntimeMonitor />}
      <AssistantEventHandler />
      <AssistantContextHandler />
      <PerformanceMonitor />
    </>
  )
})
AssistantHandlers.displayName = 'AssistantHandlers'
